<template lang="pug">
.lk-payment
	.lk-payment__container
		v-loader(:loading="loading")
		component.lk-payment__title.h1(v-if="data && data.title" :is="data.titleLevel || 'h1'") {{data?.title}}
		.lk-payment__content
			.lk-payment__sort(v-if="state && state.sort")
				v-field.field-no-radio.field--row(
					:field="{type: 'table-sort', options: state.sort.options}"
					v-model="state.sort"
					@update:model-value="requestDataLoad")
			.lk-payment__rows
				template(
					v-for="({prefixId = 'ID', items, link},index) in data?.items"
					:key="index" )
					.lk-payment__row
						v-payment(:data-source="{prefixId, items, link}"
							@action="handleClick"
						)
		.lk-payment__pagination(v-if="page && page.count > page.limit")
			v-page-nav(:page="page" :limits="limits" @navigate="navigate")

</template>

<script>
	import sourceMixin from '../components/mixins/v-mixin-source.vue';

	export default {
		mixins: [
			sourceMixin,
		],

		data() {
			return {
				data: null,
				page: null,
				state: {
					sort: null,
				}
			}
		},

		methods: {

			dataSet(data) {
				this.data = data;
				this.page = data.page;
				this.limits = data.limits;
				this.state.sort = data.sort;
			},

			handleClick(event) {
				const {action = null, id = null} = event;

				if(!action) return;

				switch (action) {
					case 'make_it_paid' :
						this.reportForChange(action, id);
						break;
					case 'update' :
						this.reportForChange(action, id);
						break;
					case 'deactivate' :
						this.reportForChange(action, id);
						break;
					case 'remove' :
						this.reportForChange(action, id);
						break;
				}
			},

			reportForChange(action = null, id) {
				if(!action) return;
				this.dataLoad({
					url: this.data.remote,
					delay: true,
					data: {
						id,
						action
					}
				});
			},
			requestDataLoad() {
				this.dataLoad({
					url: this.data.remote,
					delay: true,
					data: {
						page: this.page,
						state: this.state,
						limits: this.limits.value
					}
				});
			},
			navigate(page) {
				this.page.offset = page.offset;
				this.page.limit = page.limit;
				this.requestDataLoad();
			},

		}

	}
</script>
